import React from 'react';
import Modal from 'emerald-ui/lib/Modal';
import Avatar from 'emerald-ui/lib/Avatar';
import Button from 'emerald-ui/lib/Button';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Modal, componentName: 'Modal' }], 'Modal'),
  description: `A Modal is a raised panel with overlay, used to guide the user's focus into a certain process.`,
  codeSamples: [
    {
      title: 'Default',
      scope: { Avatar, Button, Modal, React },
      code: `class DefaultModal extends React.Component {
  constructor() {
    super(this.props);
    this.state = { show: false };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }
  // You can use here an arrow function instead to avoid using binding in the constructor:
  // open = () => {}
  open() {
    this.setState({ show: true });
  }
  // You can use here an arrow function instead to avoid using binding in the constructor:
  // close = () => {}
  close() {
    this.setState({ show: false });
  }
  render() {
    return (
      <div>
        <Button onClick={this.open}>Show Modal</Button>
        <Modal
          onHide={this.close}
          show={this.state.show}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>Edit profile</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              <Avatar style={{ marginRight: '20px' }} title="JS" size="lg" />
              <Button>Change avatar</Button>
            </div>
            <p>This Modal does not have teh dark theme applied because it's directly in the body of the document and body here does not have the dark theme class</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close} shape="flat" color="info">
              Cancel
            </Button>
            <Button color="info">Update profile</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}`,
    },
  ],
};
